import { render, staticRenderFns } from "./InitiatePOMatching.vue?vue&type=template&id=6ba60cf4&"
import script from "./InitiatePOMatching.vue?vue&type=script&lang=js&"
export * from "./InitiatePOMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports